export const basename = '/admin';
export const SideBarZIndex = 10000;
export const filtersHelperTextHeight = '1em';
